import { createSlice } from '@reduxjs/toolkit';
const MAX_CONSOLE_ERRORS = 5;
// Initial state
const initialState = {
    popupRichMapID: null,
    allRooms: [],
    allDesks: [],
    POIs: {},
    POISNameMap: {},
    showOnMap: 'All',
    isRoomFinderOpen: false,
    smartRooms: [],
    searchFilters: {
        all: false,
        meetingRooms: false,
        hotDesks: false,
        accessibleSpaces: false,
        smartRoom: false,
    },
    timeout: null,
    richMapLoaded: false,
    destinationRichMapId: null,
    qrCodeRichMapId: null,
    checkIfModelReqFlag: false,
    directions: null,
    roomSearchPopUpOpen: false,
    currentSlide: 1,
    consoleErrors: [],
    errorTrackingEnabled: true,
};
// Slice to manage UI State
export const UISlice = createSlice({
    name: 'UI',
    initialState,
    reducers: {
        // Will set room details popup to show the given richMapID, (if null, popup will close)
        setRoomDetailsPopUp: (state, action) => {
            const { payload } = action.payload;
            state.popupRichMapID = payload;
        },
        setRoomDataFromMap: (state, action) => {
            const { payload } = action.payload;
            state.allRooms = payload;
        },
        setDeskDataFromMap: (state, action) => {
            const { payload } = action.payload;
            state.allDesks = payload;
        },
        setPOIDataFromMap: (state, action) => {
            const { payload } = action.payload;
            state.POIs = payload.POIs;
            state.POISNameMap = payload.POISNameMap;
        },
        setShowOnMap: (state, action) => {
            const { payload } = action.payload;
            state.showOnMap = payload;
        },
        setRoomFinderOpen: (state, action) => {
            const { payload } = action.payload;
            state.isRoomFinderOpen = payload;
        },
        setSmartRooms: (state, action) => {
            const { payload } = action.payload;
            state.smartRooms = payload;
        },
        setSearchFilters: (state, action) => {
            const { payload } = action.payload;
            state.searchFilters = payload;
        },
        setTimeoutId: (state, action) => {
            const { payload } = action.payload;
            state.timeout = payload;
        },
        setRichMapLoading: (state, action) => {
            const { payload } = action.payload;
            state.richMapLoaded = payload;
        },
        setDirectionsPanel: (state, action) => {
            const { payload } = action.payload;
            state.destinationRichMapId = payload;
        },
        checkIfModelRequired: (state) => {
            // Toggle a flag, which will be caught by useEffect to check if model is to be placed or not on the floor
            state.checkIfModelReqFlag = !state.checkIfModelReqFlag;
        },
        setDirections: (state, action) => {
            const { payload } = action.payload;
            state.directions = payload;
        },
        setQRCodeRichMapId: (state, action) => {
            const { payload } = action.payload;
            state.qrCodeRichMapId = payload;
        },
        setRoomSearchPopUp: (state, action) => {
            const { payload } = action.payload;
            state.roomSearchPopUpOpen = payload;
        },
        setCurrentSlide: (state, action) => {
            const { payload } = action.payload;
            state.currentSlide = payload;
        },
        pushConsoleError: (state, action) => {
            const { payload } = action.payload;
            state.consoleErrors.push(JSON.stringify(payload));
            if (state.consoleErrors.length > MAX_CONSOLE_ERRORS) {
                state.consoleErrors.shift();
            }
        },
        setErrorTracking: (state, action) => {
            const { payload } = action.payload;
            state.errorTrackingEnabled = payload;
        },
    },
    selectors: {
        getUIState: (state) => state,
        getAllRooms: (state) => state.allRooms,
        getAllDesks: (state) => state.allDesks,
        getPOIS: (state) => {
            return { POIS: state.POIs, POISNameMap: state.POISNameMap };
        },
        getShowOnMap: (state) => {
            return state.showOnMap;
        },
        getRoomFinderStatus: (state) => state.isRoomFinderOpen,
        getSmartRooms: (state) => state.smartRooms,
        getSearchFilters: (state) => state.searchFilters,
        getTimeoutId: (state) => state.timeout,
        getRichMapLoaded: (state) => state.richMapLoaded,
        getDestinationRichMapId: (state) => state.destinationRichMapId,
        getCheckIfModelReqFlag: (state) => state.checkIfModelReqFlag,
        getDirections: (state) => state.directions,
        getQrCodeRichMapId: (state) => state.qrCodeRichMapId,
        getRoomDetailsRichMapId: (state) => state.popupRichMapID,
        getRoomSearchPopUpOpen: (state) => state.roomSearchPopUpOpen,
        getCurrentSlide: (state) => state.currentSlide,
        getConsoleErrors: (state) => state.consoleErrors,
        getErrorTrackingFlag: (state) => state.errorTrackingEnabled,
    },
});
// Export actions
export const { setRoomDetailsPopUp, setRoomDataFromMap, setDeskDataFromMap, setPOIDataFromMap, setShowOnMap, setRoomFinderOpen, setSmartRooms, setSearchFilters, setTimeoutId, setRichMapLoading, setDirectionsPanel, checkIfModelRequired, setDirections, setQRCodeRichMapId, setRoomSearchPopUp, setCurrentSlide, pushConsoleError, setErrorTracking, } = UISlice.actions;
// Export selectors
export const { getUIState, getAllRooms, getAllDesks, getPOIS, getShowOnMap, getRoomFinderStatus, getSmartRooms, getSearchFilters, getTimeoutId, getRichMapLoaded, getDestinationRichMapId, getCheckIfModelReqFlag, getDirections, getQrCodeRichMapId, getRoomDetailsRichMapId, getRoomSearchPopUpOpen, getCurrentSlide, getConsoleErrors, getErrorTrackingFlag, } = UISlice.selectors;
